import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import ExpandLess from 'material-ui/svg-icons/navigation/expand-less'
import { formatTime } from './utils'
import css from './styles/email.css'

const iframeStyleString = `<style>
  html {
    margin: 0;
  }
   body {
    color: #243641;
    font-family: sans-serif;
    font-size: 14px;
    margin: 0;
    overflow: hidden;
  }
  blockquote {
    border-left: 1px solid #cccccc;
    font-size: 12px;
    padding-left: 4px;
  }
  a {
    pointer-events: auto;
  }
  </style>`

class Email extends Component {
  static propTypes = {
    message: PropTypes.shape({
      id: PropTypes.number.isRequired,
      body: PropTypes.string.isRequired,
    }).isRequired,
    isSelected: PropTypes.bool.isRequired,
    handleClick: PropTypes.func.isRequired,
  }

  componentDidMount = () => {
    this.resizeEmailIframe()
  }

  handleClick = () => {
    const val = this.props.isSelected
    ? false // when you want to 'unselect' the email in view
    : this.props.message.id
    this.props.handleClick(val)
  }

  getSenderName = () => {
    const { message } = this.props

    if (!message) { return '' }
    const match = !!message.from && message.from.match(/<[\s\S]*>/)
    return match || message.from
  }

  resizeEmailIframe = (count = 0) => {
    setTimeout(() => {
      if (this.iframe && this.iframe.contentDocument && this.iframe.contentDocument.scrollingElement) {
        this.iframe.height = Math.max(this.iframe.contentDocument.scrollingElement.scrollHeight, 100)
      } else if (count <= 5) {
        this.resizeEmailIframe(count + 1)
      }
    }, 200)
  }

  render() {
    const { message, isSelected } = this.props
    const dateTimeStamp = message.sent_at
      ? formatTime(message.sent_at, true)
      : formatTime(message.created_at, true)
    const emailClasses = cx(
      css.email,
      { [css.isSelected]: isSelected }
    )

    return (
      <div
        className={emailClasses}
        onClick={this.handleClick}
      >
        <div className={css.sender}>
          {this.getSenderName()}
        </div>
        <div className={css.date}>
          {dateTimeStamp}
        </div>
        <iframe
          title={message.id}
          height="100"
          className={css.iframe}
          srcDoc={`${iframeStyleString}<base target='__blank'>${message.body}`} // this is a bit of a hack. we need to properly insert this into the head
          sandbox="allow-popups allow-popups-to-escape-sandbox allow-same-origin"
          ref={(frame) => { this.iframe = frame }}
        />
        {isSelected && <div className={css.showLess}><ExpandLess /> </div>}
      </div>
    )
  }
}

export default Email



// WEBPACK FOOTER //
// ./src/components/Messages/Email.js